import React from 'react';

export interface IconLifeProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconLife: React.FC<IconLifeProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path fillRule="evenodd" clipRule="evenodd" d="M16.8985 8.69486C16.4411 8.47045 16.0492 8.13303 15.7592 7.71901L12.0267 12.1254L7.83644 7.17859H15.4586C15.3039 6.81678 15.2182 6.41839 15.2182 6C15.2182 5.89142 15.224 5.78419 15.2352 5.67859H6.21822H4.60001L5.64594 6.91335L11.4545 13.7705L12.0267 14.4461L12.599 13.7705L16.8985 8.69486Z" fill={fill || "#020617"} /> <path d="M12.1384 13.2858V21.0001" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" /> <path d="M8.73398 21H15.5425" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" /> <path d="M9 6L5.90426 3H2.5" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" /> <circle cx="18" cy="6" r="3" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />  
    </svg>
  );
};

export default IconLife;
